import React from 'react'
export const LicenceLimitContext = React.createContext()